import React, { Component } from 'react';
import $ from 'jquery';
import SlidingPanels from '../components/SlidingPanels';

require('jquery.scrollto');

export default class BBQInstallation extends Component {
    componentDidMount() {
        this.props.clearSlides();
        $.get('/data/slides/about.json').done(function (data) {
            for (let i = 0, len = data.length; i < len; i++) {
                this.props.addSlide(data[ i ]);
            }
        }.bind(this));

        $(window).scrollTo(30, '0.5s');

        document.title = `Barbeque Installation Sydney - C&A Assembly & Installation Solution`;
    }

    render() {
        return (
            <div>
                <SlidingPanels {...this.props} />

                <div className="container">
                    <div className="row">
                        <div className="col-xs-12">
                            <h1>Barbeque Installation</h1>

                            
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/BBQInstallation.js